const addFileToFormData = (file: File): FormData => {
  const formData = new FormData();
  formData.append("file", file);

  return formData;
};

const functions = {
  addFileToFormData,
};

export function useUpload(): typeof functions {
  return functions;
}
